export const isString = (value: unknown) => {
  return typeof value === "string" || "value is not String";
};
